<template>
	<button
		:type="type"
		:class="buttonInfo.class"
		@click="$router.push({ name: buttonInfo.page })"
	>
		{{ buttonInfo.name }}
	</button>
</template>

<script>
export default {
	name: 'MainButton',
	props: {
		buttonInfo: {
			type: Object,
		},
		type: {
			type: String,
			default: 'button',
		},
	},
};
</script>
